module.exports = __webpack_public_path__ + "images/sprites/ui/tips_balloon_1e22f8b52e8ccb39c053212edefedeb2.png";